// import React, { useState, useEffect } from "react";
// import { Bar } from "react-chartjs-2";
// import {
//   Chart as ChartJS,
//   CategoryScale,
//   LinearScale,
//   BarElement,
//   Tooltip,
//   Legend,
// } from "chart.js";
// import performRequest from "../../../api/request";
// import { CustomErrorResponse } from "../../../CustomComponent/custom_error_response";
// import { Toast } from "../../../CustomComponent/toast";
// import LoadingPage from "../../../Components/layouts/loading";

// ChartJS.register(CategoryScale, LinearScale, BarElement, Tooltip, Legend);

// const TransferLeadChart = () => {
//   const [leadTransferCount, setLeadTransferCount] = useState([]);
//   const [loading, setLoading] = useState(false);
//   const [isMobile, setIsMobile] = useState(window.innerWidth < 768);

//   useEffect(() => {
//     const handleResize = () => {
//       setIsMobile(window.innerWidth < 768);
//     };
//     window.addEventListener("resize", handleResize);
//     return () => window.removeEventListener("resize", handleResize);
//   }, []);

//   useEffect(() => {
//     setLoading(true);
//     performRequest("GET", `/leads/getTransferLeadCount`)
//       .then((res) => {
//         if (res.status === 200) {
//           setLeadTransferCount(res.data);
//         } else {
//           Toast("error", "Error while getting data!");
//         }
//       })
//       .catch((err) => {
//         CustomErrorResponse(err);
//       })
//       .finally(() => setLoading(false));
//   }, []);

//   const cData = leadTransferCount;

//   // Step 1: Get all unique users (from transferBy and enquiryAssign)
//   const users = Array.from(
//     new Set(cData.flatMap((d) => [d.transferBy, d.enquiryAssign]))
//   );

//   // Step 2: Calculate sent and received counts
//   const sentCounts = users.map((user) =>
//     cData
//       .filter((d) => d.transferBy === user)
//       .reduce((sum, d) => sum + d.enquiryAssignCount, 0)
//   );

//   const receivedCounts = users.map((user) =>
//     cData
//       .filter((d) => d.enquiryAssign === user)
//       .reduce((sum, d) => sum + d.enquiryAssignCount, 0)
//   );

//   const chartData = {
//     labels: users,
//     datasets: [
//       {
//         label: "Sent",
//         data: sentCounts,
//         backgroundColor: "rgba(255, 99, 132, 0.6)",
//       },
//       {
//         label: "Received",
//         data: receivedCounts,
//         backgroundColor: "rgba(54, 162, 235, 0.6)",
//       },
//     ],
//   };

//   const options = {
//     responsive: true,
//     plugins: {
//       legend: {
//         position: "bottom",
//       },
//       tooltip: {
//         mode: "index",
//         intersect: false,
//       },
//     },
//     scales: {
//       y: {
//         beginAtZero: true,
//       },
//     },
//   };

//   return (
//     <div className="card p-4">
//       <h3 className="card-title">Lead Transfer Overview</h3>
//       {loading ? <LoadingPage /> : <Bar data={chartData} options={options} />}
//     </div>
//   );
// };

// export default TransferLeadChart;

// WeeklyTransferChart.js
import React, { useEffect, useState } from "react";
import { Bar } from "react-chartjs-2";
import {
  Chart as ChartJS,
  CategoryScale,
  LinearScale,
  BarElement,
  Tooltip,
  Legend,
} from "chart.js";
import performRequest from "../../../api/request";
import { Toast } from "../../../CustomComponent/toast";
import LoadingPage from "../../../Components/layouts/loading";

ChartJS.register(CategoryScale, LinearScale, BarElement, Tooltip, Legend);

const TransferLeadChart = () => {
  const [chartData, setChartData] = useState(null);
  const [weekLabel, setWeekLabel] = useState("");
  const [loading, setLoading] = useState(false);
  const [data,setData] = useState([]);

  useEffect(() => {
    setLoading(true);
    performRequest("GET", `/leads/getTransferLeadCount`)
      .then((res) => {
        if (res.status === 200) {
          const all = res.data;
          setData(res.data);
          const allWeekLabels = [...new Set(all.map((d) => d.weekLabel))];
          const latestWeek = allWeekLabels.sort().pop(); // get latest
          setWeekLabel(latestWeek);

          const currentWeekData = all.filter((d) => d.weekLabel === latestWeek);
          const labels = currentWeekData.map((d) => d.user);
          const sentCounts = currentWeekData.map((d) => d.sent);
          const receivedCounts = currentWeekData.map((d) => d.received);

          setChartData({
            labels,
            datasets: [
              {
                label: "Sent",
                data: sentCounts,
                backgroundColor: "#3b82f6",
              },
              {
                label: "Received",
                data: receivedCounts,
                backgroundColor: "#10b981",
              },
            ],
          });
        } else {
          Toast("error", "Failed to load transfer data");
        }
      })
      .catch(() => {
        Toast("error", "Something went wrong");
      })
      .finally(() => setLoading(false));
  }, []);

  const options = {
    responsive: true,
    plugins: {
      legend: {
        position: "bottom",
      },
      tooltip: {
        mode: "index",
        intersect: false,
      },
    },
    scales: {
      y: {
        beginAtZero: true,
        ticks: {
          precision: 0,
        },
      },
    },
  };

  return (
    <>
      <div
        style={{
          padding: 20,
          background: "#fff",
          borderRadius: 8,
          boxShadow: "0 1px 4px rgba(0,0,0,0.1)",
        }}
      >
        <h3>
          Lead Transfers - {weekLabel}
        </h3>
        {loading ? (
          <LoadingPage />
        ) : (
          chartData && <Bar data={chartData} options={options} />
        )}
      </div>
      <div className="card mt-5">
        <div className="table-responsive">
          <table className="table table-vcenter">
            {/* <thead>
            <tr>
              <th>Sr</th>
              <th>Week</th>
              <th>Farm Tranning</th>
              <th>S.I</th>
              <th>H.M</th>
              <th>All Other</th>
              <th>S.I Kit</th>
              <th>AIF Report</th>
              <th>Total Revenue</th>
            </tr>
          </thead>
          <tbody>
            {console.log('current month ', currentMonthData)}
            {currentMonthData.map((item, index) => (
              <>
                <tr
                  key={index}
                  style={{
                    backgroundColor:
                      item.weekLabel === getCurrentWeekLabel()
                        ? "rgb(12, 166, 120,0.1)"
                        : "",
                  }}
                >
                  <td>{index + 1}</td>
                  <td>{item.weekLabel}</td>
                  {products.map((product, i) => (
                    <td key={i}>
                      ₹{item.revenue?.[product]?.amount ?? 0} (
                      {item.revenue?.[product]?.count ?? 0}){" "}
                    </td>
                  ))}
                  <td>₹{item?.total}</td>
                </tr>
              </>
            ))}
          </tbody> */}
            <thead>
              <tr>
                <th className="p-3">
                  <span className="fs-2">Sr</span>
                </th>
                <th className="p-3">
                  <span className="fs-2">Week</span>
                </th>
                <th>
                  <span className="fs-2">Name</span>
                </th>
                <th>
                  <span className="fs-2">Sent</span>
                </th>
                <th>
                  <span className="fs-2">
                    <b>Received</b>
                  </span>
                </th>
              </tr>
            </thead>

            <tbody>
              {data.map((item, index) => (
                <tr
                  key={index}
                  // style={{
                  //   backgroundColor:
                  //     item.weekLabel === getCurrentWeekLabel()
                  //       ? "rgba(12, 166, 120, 0.1)"
                  //       : "rgba(255, 255, 0, 0.2)",
                  // }}
                >
                  <td>
                    <span className="fs-2">
                      <b>{index + 1}</b>
                    </span>
                  </td>
                  <td>
                    <span className="fs-2">
                      <b>{item.weekLabel}</b>
                    </span>
                  </td>
                  <td>
                    <span className="fs-2">
                      <b>{item.user}</b>
                    </span>
                  </td>
                  <td>
                    <span className="fs-2">
                      <b>{item?.sent}</b>
                    </span>
                  </td>
                  <td>
                    <span className="fs-2">
                      <b>{item?.received}</b>
                    </span>
                  </td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      </div>
    </>
  );
};

export default TransferLeadChart;
